import {createFeatureSelector} from '@ngrx/store';
import {Info} from '../../services/info/types/info';
import {Features} from '../features';

export const selectInfo = createFeatureSelector<Info>(Features.INFO)
